// client/src/hooks/useIndexedFile.js

import { useState, useCallback } from 'react';
import indexedFileAPI from '../api/indexedFileAPI';

const useIndexedFile = () => {

  const [indexStatus,  setIndexStatus]  = useState(null);
  const [isReindexing, setIsReindexing] = useState(false);
  const [error,        setError]        = useState(null);

  const reindexContent = useCallback(async (force = false) => {
    setIsReindexing(true);
    setError(null);
    try {
      const response = await indexedFileAPI.reindexContent(force);
      if (!response.success) throw new Error(response.error || 'Reindex failed.');
      return response;
    } catch (err) {
      setError(err.message);
      return { success: false, error: err.message };
    } finally {
      setIsReindexing(false);
    }
  }, []);

  const loadIndexStatus = useCallback(async () => {
    setError(null);
    try {
      const response = await indexedFileAPI.getIndexStatus();
      if (!response.success) throw new Error(response.error || 'Failed to load status.');
      setIndexStatus(response);
      return response;
    } catch (err) {
      setError(err.message);
      return null;
    }
  }, []);

  const reindexCourses = useCallback(async () => {
    setIsReindexing(true);
    setError(null);
    try {
      const response = await indexedFileAPI.reindexCourses();
      if (!response.success) throw new Error(response.error || 'Course reindex failed.');
      return response;
    } catch (err) {
      setError(err.message);
      return { success: false, error: err.message };
    } finally {
      setIsReindexing(false);
    }
  }, []);

  const clearError = useCallback(() => setError(null), []);

  return {
    indexStatus,
    isReindexing,
    error,
    reindexContent,
    loadIndexStatus,
    reindexCourses,
    clearError,
  };
};

export default useIndexedFile;